import { useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ThemedResetIcon } from "assets/CXFIcons/Designer/ContextActions";
import { setContext } from "redux/actions/flowDesigner/editorContextActionCreator";
import { cleanFlowContext } from 'helpers/common.js';
import { TabContextApi } from "layouts/Flow Designer/context";
import { toast } from "react-toastify";
import ContextHeaderButton from "../ContextHeaderButton";

const ResetContextButton = () => {
  const { context } = useSelector((store) => store?.designer?.editorContext);
  const { autoSaveFlow } = useContext(TabContextApi);
  const dispatch = useDispatch();

  const resetContextSteps = (contextCopy) => {
    cleanFlowContext(contextCopy);
    return contextCopy;
  };

  const handleResetContext = () => {
    try {
      let contextCopy = { ...context };

      // clear the inputData
      // clear the outputData
      // remove the other properties from the componentData
      // remove some the data that's not included in the variables
      const updatedContext = resetContextSteps(contextCopy);

      dispatch(setContext(updatedContext));
      autoSaveFlow();
      toast.success("Context has been reset successfully");
    } catch (error) {
      console.error("Error while resetting context", error);
    }
  };

  return (
    <ContextHeaderButton icon={<ThemedResetIcon />} label="Reset" action={handleResetContext} />
  );
};

export default ResetContextButton;
